<template>
  <v-container fluid class="pa-2">

    <div v-if="isLoading" class="d-flex justify-center my-3">
      <v-progress-circular
          color="primary"
          indeterminate
          size="64"
      ></v-progress-circular>
    </div>
    
    
    <!-- NEWS ITEMS -->
    <div class="d-flex flex-wrap align-stretch ma-0 pa-0" v-if="!isLoading">
      
      <template v-for="item in newsfeed">
        <div class="col-12 col-sm-6 col-lg-3 ma-0 pa-2" :key="item.identifier">
          <v-card
              height="100%"
              link
              class="rounded-lg d-flex flex-column"
              @click.prevent="openItem(item)"
          >
            <v-img
                v-if="item.thumbnail"
                :src="item.thumbnail"
            ></v-img>
            <v-card-title class="text-break"><strong>{{ item.title }}</strong></v-card-title>
            <v-card-text class="fill-height">
              <div v-if="item.shortDescription" v-html="item.shortDescription"></div>
            </v-card-text>
          </v-card>
        </div>
      </template>

    </div>
    
    
    <!-- NEWS ITEM DIALOG -->
    <v-dialog
        v-model="showItemDialog"
        max-width="600"
        scrollable
    >
      <v-card
          class="rounded-lg d-flex flex-column"
      >
        <v-img
            v-if="selectedItem.image"
            :src="selectedItem.image"
            max-height="400"
        ></v-img>
        <v-btn
            class="mt-3"
            color="primary"
            fab
            depressed
            dark
            small
            absolute
            right
            @click.prevent="showItemDialog = false"
        >
          <v-icon small>fal fa-close</v-icon>
        </v-btn>
        <v-card-title v-if="selectedItem.title" class="text-break"><strong>{{ selectedItem.title }}</strong></v-card-title>
        <v-card-text class="fill-height">
          <div v-if="selectedItem.description" v-html="selectedItem.description"></div>
        </v-card-text>
      </v-card>
    </v-dialog>
    
  </v-container>
</template>

<script>

import api from "@/api/api";

export default {
  name: "m2h-news",
  data() {
    return {
      isLoading: true,
      newsfeed: [],
      showItemDialog: false,
      selectedItem: {}
    }
  },

  mounted(){
    this.fetchNewsfeed()
  },

  methods: {
    async fetchNewsfeed(){
      this.isLoading = true
      let newsfeed = []
      newsfeed = await api.newsItems.getList("newsfeed", this.$i18n.locale).then((res) => { return res.data })
      if (newsfeed.length){
        this.newsfeed = newsfeed.sort((a, b) => {
          return this.$moment(a.created).unix() - this.$moment(b.created).unix()
        })
        for (const item of this.newsfeed) {
          let image = await this.fetchImage(item.imageAssetId)
          let thumbnail = await this.fetchImage(item.thumbnailAssetId)
          item.image = image
          item.thumbnail = thumbnail
        }
      }
      this.isLoading = false
    },

    async fetchImage(id){
      if (id){
        return await api.newsItems.getSas(id)
            .then((res) => {
              return res.data
            })
            .catch(() => {
              return ''
            })
      } else {
        return ''
      }
    },
    
    openItem(item){
      this.selectedItem = item
      this.showItemDialog = true
        this.$root.$emit('post-news-opened', { id: item.identifier })
    }
  }
}
</script>

<style scoped>

</style>
